import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("bdr-jobs")!;

export const Route = createFileRoute("/bdr-jobs")({
  head: () => pageHead("/bdr-jobs"),
  component: () => <CategoryPage category={category} />,
});
